module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-edit-e04be159.svg";